<template lang="pug">
    v-form.c-form(autocomplete="off")
        v-layout(raw wrap)
            v-flex(xs12)

                // Role selection
                v-select(
                    :items="$t('selection.managers')"
                    :label="$t('fields.select_role')"
                    name="Role"
                    v-model.lazy="model.role"
                    append-icon="expand_more"
                    outline
                )

            v-flex(xs12)

                // Full Name field
                v-text-field(
                    :error-messages="errors.collect('fullName')"
                    :data-vv-as="$t('fields.fullName')"
                    :label="$t('fields.fullName')"
                    name="fullName"
                    v-model.lazy="model.fullName"
                    v-validate="'required|min:2|max:72'"
                    outline
                )

            v-flex(xs12)

                // Email field
                v-text-field(
                    :error-messages="errors.collect('email')"
                    :data-vv-as="$t('fields.email')"
                    :label="$t('fields.email')"
                    name="email"
                    type="email"
                    v-model.lazy="model.email"
                    v-validate="'required|email'"
                    outline
                )

            v-flex(xs12)

                // Phone field
                v-text-field(
                    :error-messages="errors.collect('phone')"
                    :data-vv-as="$t('fields.phone')"
                    :label="$t('fields.phone')"
                    name="phone"
                    v-model.lazy="model.phone"
                    v-validate="'required|min:6'"
                    mask="###-###-######-####"
                    outline
                )

            v-flex(xs12 v-if="model.data && model.role === 'instructor'")

                // Instructor Position
                v-text-field(
                    name="position"
                    :label="$t('fields.position')"
                    v-model="model.position"
                    outline
                )

            v-flex(xs12 v-if="model.data && model.role === 'instructor'")

                // Instructor Information
                div.mb-2 Instructor Information
                froala(
                    v-model="model.information"
                    :tag="'textarea'"
                    :config="config"
                )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions } from 'vuex';
    import '~/plugins/froala';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        data() {
            return {
                config: {
                    events: {
                        'froalaEditor.initialized': function() {}
                    },
                    toolbarButtons: {
                        moreText: {
                            buttons: [
                                'bold',
                                'italic',
                                'fontSize',
                                'underline',
                                'strikeThrough',
                                'textColor',
                                'backgroundColor',
                                'subscript',
                                'superscript',
                                'fontFamily',
                                'inlineClass',
                                'inlineStyle'
                            ]
                        },
                        moreParagraph: {
                            buttons: [
                                'alignLeft',
                                'alignCenter',
                                'formatOLSimple',
                                'alignRight',
                                'alignJustify',
                                'formatOL',
                                'formatUL',
                                'paragraphFormat',
                                'paragraphStyle',
                                'lineHeight',
                                'outdent',
                                'indent',
                                'quote'
                            ]
                        },
                        moreMisc: {
                            buttons: ['undo', 'redo', 'fullscreen']
                        }
                    },
                    toolbarVisibleWithoutSelection: false,
                    quickInsertEnabled: false,
                    heightMax: 500,
                    heightMin: 300,
                    zIndex: 2501,
                    key:
                        'aLF3c1B8B7C4C2F2F2C-7gmokdhdrH-8ekB-16uD1qG-10yiB3B9B6A5C2C4F4H3A2H3=='
                }
            };
        },
        computed: {
            ...mapFields('managers', {
                model: 'manager'
            })
        },
        methods: {
            ...mapActions('managers', ['update']),

            /**
             * Create manager on submit
             * @returns {boolean}
             */
            async submitForm() {
                // Validate all fields
                const validation = await this.$validator.validateAll();

                // Check validation pass
                if (!validation) return;

                // Call store action
                this.update();
            }
        }
    };
</script>
